import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationConstants } from '../../../configs/app.constants';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { SnackbarService } from '../../../services/common/snackbar.service';
import { LoaderService } from '../../../services/common/loader.service';
import codes from 'country-calling-code';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  signupForm!: FormGroup;
  formSubmitted: boolean = false;
  // genders = ['MALE', 'FEMALE', 'OTHER'];
  countryMaster: any[] =
    [
      { name: 'Australia', code: 'AU', phonecode: 61 },
      { name: 'India', code: 'IN', phonecode: 91 },
      { name: 'Japan', code: 'JP', phonecode: 81 },
      { name: 'Spain', code: 'ES', phonecode: 34 },
      { name: 'United States', code: 'US', phonecode: 1 }
    ];
  selectedCountry: any;
  selectedCountryForFlag: any = null;
  showCountryCodeValidationBlock: boolean = false;

  constructor(
    private authenticationServ: AuthenticationService,
    private snackbarServ: SnackbarService,
    private loaderServ: LoaderService,
  ) { }
  ngOnInit() {
    this.signupForm = new FormGroup({
      firstName: new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.pattern(ValidationConstants.userAccountStrategy.NAME_PATTERN)]),
      lastName: new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.pattern(ValidationConstants.userAccountStrategy.NAME_PATTERN)]),
      email: new FormControl('', [Validators.required, Validators.pattern(ValidationConstants.userAccountStrategy.EMAIL_PATTERN)]),
      companyName: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      // licenceNumber: new FormControl('', Validators.required),
      phone_no: new FormControl('', [Validators.required, Validators.pattern(ValidationConstants.userAccountStrategy.PHONE_NUMBER), Validators.minLength(ValidationConstants.userAccountStrategy.PHONE_NUMBER_MIN), Validators.maxLength(ValidationConstants.userAccountStrategy.PHONE_NUMBER_MAX)]),
      // gender: new FormControl('', Validators.required),
      address: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      referralCode: new FormControl('')
    });
    this.countryMaster = codes.map(({ country, isoCode2, countryCodes }) => ({
      name: country,
      code: isoCode2,
      phonecode: countryCodes[0]
    }));
    // default value for country code dropdown
    this.selectedCountry = {
      "name": "United States",
      "code": "US",
      "phonecode": "1"
    }
  }
  onCountryChange(event: any) {
    this.showCountryCodeValidationBlock = false;
  }

  onSubmit(event: any) {
    if (this.signupForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;
      let mobile = "+" + this.selectedCountry.phonecode + " " +
        (this.signupForm?.get('phone_no')?.value ? this.signupForm?.get('phone_no')?.value : '');
      let loginOrgPayload = {
        firstName: this.signupForm?.get('firstName')?.value?.trim(),
        lastName: this.signupForm?.get('lastName')?.value?.trim(),
        email: this.signupForm?.get('email')?.value?.trim(),
        companyName: this.signupForm?.get('companyName')?.value?.trim(),
        // licenceNumber: this.signupForm?.get('licenceNumber')?.value,
        address: this.signupForm?.get('address')?.value ? this.signupForm?.get('address')?.value?.trim() : '',
        referralCode: this.signupForm?.get('referralCode')?.value ? this.signupForm?.get('referralCode')?.value?.trim() : '',
        phone_no: mobile,
      }
      this.authenticationServ.contactToAdmin(loginOrgPayload).subscribe((res) => {
        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
        if (res.success) {
          this.formSubmitted = true;
          this.signupForm.reset();
          this.snackbarServ.showSuccess(res.msg);
        }
      }, (err) => {
        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
        this.snackbarServ.showError(err.error?.msg || 'Submission failed');
      });
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  allowOnlyText(event: KeyboardEvent) {
    const charCode = event.charCode;
    // Allow A–Z and a–z (charCode 65–90 and 97–122), plus space (32)
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode === 32
    ) {
      return;
    }
    event.preventDefault();
  }


  noWhitespaceValidator(control: AbstractControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

}
